import { Component, OnInit, Input, Output } from '@angular/core';
import { LoginService } from '../home/login.service';
import { ICartItems } from '../onlineorder/cartitems';
import { OnlineOrderService } from '../onlineorder/onlineorder.service';
import { Router, NavigationExtras } from '@angular/router';
import { AppComponent } from '../app.component';
import { FormBuilder, Validators } from '@angular/forms';
import { CheckoutService } from './checkout.service';
import { CreateAccountService } from '../account/create-account.service';
import { IZip } from '../account/zipinfo';
import { OrderService } from '../onlineorder/order.service';
import { TranslateService } from '@ngx-translate/core';
import { AdminService } from '../admin/admin.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

@Component({
  standalone: false,
  selector: 'custship',
  templateUrl: './shippinginfo.component.html',
})
export class ShippingInfoComponent implements OnInit {
  public pageTitle: string = 'Shipping Information';
  public subTotal: number = 0;
  states!: string[];
  zipErrorMessage!: string;
  counties!: string[];
  zipResults!: IZip[];
  zipGood!: boolean;

  //states = [];
  cities!: string[];
  errorMessage!: string;
  public shippingForm = this.fb.group({
    custFirst: ['', Validators.required],
    custLast: ['', Validators.required],
    custStreet: ['', Validators.required],
    custStreet2: [''],
    custCity: ['', Validators.required],
    custState: ['', Validators.required],
    custCounty: ['', Validators.required],
    custZip: [
      '',
      Validators.compose([
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(10),
      ]),
    ],
    custPhone: ['', Validators.required],
    custEmail: ['', Validators.required],
  });
  public caption: string;
  public transErrMsg: string;
  translatedText = '';
  constructor(
    public fb: FormBuilder,
    private _loginService: LoginService,
    private orderService: OrderService,
    private router: Router,
    private app: AppComponent,
    public checkout: CheckoutService,
    private _createAccountService: CreateAccountService,
    public translate: TranslateService,
    public admin: AdminService,
    public spinner: NgxSpinnerService,
    public toaster: ToastrService,
    private onlineorder: OnlineOrderService,
  ) {}
  getLocale(): any {
    var currentLocale = localStorage.getItem('locale');
    return currentLocale;
  }
  googleTranslateCall(textToTrans: string, targetLang: string): string {
    let model = {
      q: [textToTrans],
      target: targetLang,
    };
    this.admin.googleTranslate(model).subscribe((response: any) => {
      //console.log('Translate Call: ' + response.data.translations[0].translatedText);
      this.translatedText = response.data.translations[0].translatedText;
      return this.translatedText;
    });
    return '';
  }
  showError(errorMessage: string, subject: string, staticErrorMsg: boolean) {
    //use this for dynamic error messages
    if (staticErrorMsg === false) {
      let locale = this.getLocale();
      if (locale !== 'en') {
        //were gonna do it nested, couldn't do it as a standalone method.
        let model = {
          q: [errorMessage],
          target: locale,
        };

        this.admin.googleTranslate(model).subscribe(
          (response: any) => {
            let res = response.data.translations[0].translatedText as string;
            this.translatedText = response.data.translations[0]
              .translatedText as string;
            this.transErrMsg = this.translatedText;
            localStorage.setItem('translatedText', res);
          },
          (error) => console.log(error),
          () => {
            this.translate.get(subject).subscribe(
              (res: string) => {
                this.caption = res;
                console.log(res);
              },
              (error) => console.log(error),
              () => {
                this.spinner.hide();
                //once the caption is translated, fire off the toaster popup
                this.toaster.error(this.transErrMsg, this.caption, {
                  timeOut: 5000,
                });
                localStorage.removeItem('translatedText');
              },
            );
          },
        );

        //this.transErrMsg =  this.translatedText;
      } else {
        this.translate.get(subject).subscribe(
          (res: string) => {
            this.caption = res;
            console.log(res);
          },
          (error) => console.log(error),
          () => {
            this.transErrMsg = errorMessage;
            this.spinner.hide();
            //once the caption is translated, fire off the toaster popup
            this.toaster.error(this.transErrMsg, this.caption, {
              timeOut: 5000,
            });
            localStorage.removeItem('translatedText');
          },
        );
      }
    } else {
      // translate the error message - not dynamic
      this.translate.get(errorMessage).subscribe((res: string) => {
        this.transErrMsg = res;
        console.log(res);
      });

      // translate the caption
      this.translate.get(subject).subscribe((res: string) => {
        this.caption = res;
        console.log(res);
      });
      this.spinner.hide();
      //show the toaster popup
      this.toaster.error(this.transErrMsg, this.caption, {
        timeOut: 5000,
      });
    }
  }
  updateShippingAddress() {
    this.checkout
      .updateOnlineOrderAddress2(
        this.shippingForm.controls.custFirst.value,
        this.shippingForm.controls.custLast.value,
        this.shippingForm.controls.custPhone.value,
        this.shippingForm.controls.custEmail.value,
        this.shippingForm.controls.custStreet.value,
        this.shippingForm.controls.custStreet2.value,
        this.shippingForm.controls.custCity.value,
        this.shippingForm.controls.custState.value,
        this.shippingForm.controls.custZip.value,
        this.shippingForm.controls.custCounty.value,
      )
      .subscribe({
        next: (n) => {
          console.log('Result from adress update: ' + n);
          localStorage.setItem(
            'shippingData',
            JSON.stringify({
              first: this.shippingForm.controls.custFirst.value,
              last: this.shippingForm.controls.custLast.value,
              street1: this.shippingForm.controls.custStreet.value,
              street2: this.shippingForm.controls.custStreet2.value,
              city: this.shippingForm.controls.custCity.value,
              state: this.shippingForm.controls.custState.value,
              zip: this.shippingForm.controls.custZip.value,
              county: this.shippingForm.controls.custCounty.value,
              phone: this.shippingForm.controls.custPhone.value,
              email: this.shippingForm.controls.custEmail.value,
            }),
          );
        },
        error(err) {},
        complete: () => {
          this.orderService.updateShipMethodPlusTotals2().subscribe({
            next: (val) => {
              // need to set the orderInfo (BalanceDue, Shipping, Tax etc...)
              localStorage.setItem('orderInfo', JSON.stringify(val));
            },
            complete: () => {
              console.log('updated ship totals. from ship component.');
              this.onlineorder.calculateTax().subscribe(
                (thing2) => thing2,
                (error) => console.log(error),
                () => {
                  console.log('updated tax.');
                },
              );
            },
          });
        },
      });
    // this doesn't populate the fields at all. it actually is causing more issues.

    // this.checkout.updateShippingAddress(this.shippingForm.controls.custFirst.value,
    //     this.shippingForm.controls.custLast.value, this.shippingForm.controls.custPhone.value,
    //     this.shippingForm.controls.custEmail.value, this.shippingForm.controls.custStreet.value,
    //     this.shippingForm.controls.custCity.value, this.shippingForm.controls.custState.value,
    //     this.shippingForm.controls.custZip.value, this.shippingForm.controls.custCounty.value)
    //     .subscribe(thing => thing, error => console.log(error), () => {
    //         localStorage.removeItem('shippingData');

    //         localStorage.setItem('shippingData', JSON.stringify({
    //             first: this.shippingForm.controls.custFirst.value, last: this.shippingForm.controls.custLast.value, street1: this.shippingForm.controls.custStreet.value,
    //             city: this.shippingForm.controls.custCity.value, state: this.shippingForm.controls.custState.value,
    //             zip: this.shippingForm.controls.custZip.value, county: this.shippingForm.controls.custCounty.value,
    //             phone: this.shippingForm.controls.custPhone.value, email: this.shippingForm.controls.custEmail.value
    //         }));
    //         this.orderService.updateShipMethodPlusTotals2().subscribe(stuff => {
    //             //console.log(stuff);
    //             //add to orderinfo local storage item, it didnt work in the service but here it did
    //             localStorage.setItem('orderInfo', JSON.stringify(stuff));

    //         });
    //     });
  }

  ngOnInit(): void {
    //this.getStates();
    // this.checkout.getShippingAddress().subscribe(data => {
    //     let first = data.addresses[1].FirstName;
    //     let last = data.addresses[1].LastName;
    //     let street1 = data.addresses[1].Street1;
    //     let street2 = data.addresses[1].Street2;
    //     let city = data.addresses[1].City;
    //     let state = data.addresses[1].State;
    //     let zip = data.addresses[1].PostalCode;
    //     let county = data.addresses[1].County;
    //     let phone = data.addresses[1].Phone;
    //     let email = data.addresses[1].Email;
    //     if (street1) {
    //         localStorage.setItem('shippingData', JSON.stringify({
    //             first: first, last: last, street1: street1, street2: street2, city: city, state: state,
    //             zip: zip, county: county, phone: phone, email: email
    //         }));
    //     }

    // },
    //     error => this.errorMessage = error, () => {

    this.states = [];
    this.counties = [];
    this.cities = [];
    this.zipResults = [];

    var currentShipping = JSON.parse(
      localStorage.getItem('shippingData') || '{}',
    );
    //this.userId = currentUser && currentUser.userName;
    //console.log(currentShipping.street1);
    this.cities.push(currentShipping.city);
    this.counties.push(currentShipping.county);
    this.states.push(currentShipping.state);
    this.states.push();

    this.shippingForm.patchValue({
      custFirst: currentShipping.first,
      custLast: currentShipping.last,
      custStreet: currentShipping.street1,
      custStreet2: currentShipping.street2,
      custCity: currentShipping.city,
      custState: currentShipping.state,
      custZip: currentShipping.zip,
      custCounty: currentShipping.county,
      custPhone: currentShipping.phone,
      custEmail: currentShipping.email,
    });

    console.log('current shipping state: ' + currentShipping.state);
  }

  getZipInfo() {
    this.counties = [];
    this.cities = [];
    this.states = [];
    if (this.shippingForm.controls.custZip.value.length >= 5) {
      this._createAccountService
        .zipLookup(this.shippingForm.controls.custZip.value)
        .subscribe((info) => {
          this.zipResults = info;
          //console.log(this.zipResults.length);

          if (info.length !== 0) {
            this.zipGood = true;
          } else {
            this.zipGood = false;
            this.zipErrorMessage =
              'shoppingCart.shippingInformation.validation.errors.zip2';
            this.translate
              .get(this.zipErrorMessage)
              .subscribe((res: string) => {
                this.transErrMsg = res;
                this.zipErrorMessage = res;
                //console.log(res);
              });
          }

          this.zipResults.forEach(
            (item) => {
              //console.log(item.City);
              this.shippingForm.controls.custCity.setValue(item.City);
              this.shippingForm.controls.custState.setValue(item.State);
              this.shippingForm.controls.custCounty.setValue(item.County);
              if (!this.states.some((x) => x === item.State)) {
                this.states.push(item.State);
              }

              if (!this.counties.some((x) => x === item.County)) {
                this.counties.push(item.County);
              }
              if (!this.cities.some((x) => x === item.City)) {
                this.cities.push(item.City);
              }
            },
            (error: any) => {
              this.zipGood = false;
              this.zipErrorMessage =
                'shoppingCart.shippingInformation.validation.errors.zip2';
              this.translate
                .get(this.zipErrorMessage)
                .subscribe((res: string) => {
                  this.transErrMsg = res;
                  this.zipErrorMessage = res;
                  //console.log(res);
                });
            },
          );
        });
    } else {
      this.zipGood = false;
      this.zipErrorMessage =
        'shoppingCart.shippingInformation.validation.errors.zip2';
      this.translate.get(this.zipErrorMessage).subscribe((res: string) => {
        this.transErrMsg = res;
        this.zipErrorMessage = res;
        //console.log(res);
      });
    }
    return this.zipGood;
  }
  getStates() {
    this.states.push('AL');
    this.states.push('AK');
    this.states.push('AZ');
    this.states.push('AR');
    this.states.push('CA');
    this.states.push('CO');
    this.states.push('CT');
    this.states.push('DE');
    this.states.push('FL');
    this.states.push('GA');
    this.states.push('HI');
    this.states.push('ID');
    this.states.push('IL');
    this.states.push('IN');
    this.states.push('IA');
    this.states.push('KS');
    this.states.push('KY');
    this.states.push('LA');
    this.states.push('ME');
    this.states.push('MD');
    this.states.push('MA');
    this.states.push('MI');
    this.states.push('MN');
    this.states.push('MS');
    this.states.push('MO');
    this.states.push('MT');
    this.states.push('NE');
    this.states.push('NV');
    this.states.push('NH');
    this.states.push('NJ');
    this.states.push('NM');
    this.states.push('NY');
    this.states.push('NC');
    this.states.push('ND');
    this.states.push('OH');
    this.states.push('OK');
    this.states.push('OR');
    this.states.push('PA');
    this.states.push('RI');
    this.states.push('SC');
    this.states.push('SD');
    this.states.push('TN');
    this.states.push('TX');
    this.states.push('UT');
    this.states.push('VT');
    this.states.push('VA');
    this.states.push('WA');
    this.states.push('WV');
    this.states.push('WI');
    this.states.push('WY');
  }
}
